import {LocalDate, ZoneId} from "@js-joda/core";
import {Drawer, Stack, TextField} from "@mui/material";
import React from "react";
import {markMilestoneAsAchieved} from "../../../firebase/index.js";
import APXActionButtons from "../../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../../reusables/js/APXBottomSheetLayoutUtils.js";


export default function AddMilestoneAchievedBSL({uid, industryKey, mKey, onClose}: { mKey: string, industryKey: string } & BSLProps) {
	  
	  const {isOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const [disablePositiveByDefault, setDisablePositiveByDefault] = React.useState(true);
	  
	  const [dateText, setDateText] = React.useState(LocalDate.now().toString());
	  
	  
	  React.useEffect(() => {
			 setDisablePositiveByDefault(/*FALSY->*/ !!!dateText.trim());
	  }, [dateText]);
	  
	  const handleCancel = () => {
			 setDateText("");
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 const achievedOn = LocalDate.parse(dateText).atStartOfDay().atZone(ZoneId.systemDefault()).toInstant().toEpochMilli();
			 markMilestoneAsAchieved(uid, industryKey, mKey, achievedOn);
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <TextField label={"Achieved On"} variant="outlined" fullWidth required
											 type="date"
											 InputLabelProps={{shrink: true}}
											 InputProps={{inputProps: {max: LocalDate.now().toString()}}}
											 value={dateText}
											 onChange={(e) => setDateText(e.target.value)}
							  />
							  
							  <APXActionButtons onCancel={handleCancel}
													  onAdd={handleAdd}
													  disablePositiveByDefault={disablePositiveByDefault}
													  shouldShowConfirmationDialog={true}
													  positiveText={"Mark as Achieved"}
							  />
						</Stack>
				 </Drawer>
	  );
}
